export function commonAgentSdk(): string {
  return 'common-agent-sdk';
}
